import { render, staticRenderFns } from "./SerpResultsCount.vue?vue&type=template&id=04e94144&scoped=true"
import script from "./SerpResultsCount.vue?vue&type=script&lang=js"
export * from "./SerpResultsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e94144",
  null
  
)

export default component.exports